module.exports = __webpack_public_path__ + "img/cmhk.20d7e9a2.jpeg";